import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

/** GET `Report/client-user/metadata` — table columns + filter schema. */
export const fetchClientUserReportMetadata = async (data = {}) => {
  try {
    const response = await GET(REPORT.CLIENT_USER_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Report/client-user/filter` */
export const submitClientUserReportFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.CLIENT_USER_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client-user/activity/{clientId}` */
export const getClientUserActivityByClientId = async (clientId = "") => {
  const raw = String(clientId ?? "").trim();
  if (!raw) {
    toast.error("Client ID is required");
    return null;
  }
  try {
    const response = await GET(REPORT.CLIENT_USER_ACTIVITY(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
    return null;
  }
};
